/**
 * Barra fixa de compra (mobile) da PDP.
 *
 * Não implementa carrinho: delega o clique ao botão real do formulário do tema,
 * então AJAX, validação e estados de erro continuam no theme.js.
 * Sincroniza preço, variante, imagem e disponibilidade pelo evento
 * `variant:change` que o theme.js dispara no document.
 */
(function () {
  'use strict';

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function resize(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var form = document.getElementById(bar.getAttribute('data-form'));
    if (!form) return;

    var realBtn = form.querySelector('[data-add-to-cart]');
    if (!realBtn) return;

    var btn = bar.querySelector('[data-sticky-btn]');
    var priceEl = bar.querySelector('[data-sticky-price-current]');
    var wasEl = bar.querySelector('.sticky-atc__was');
    var variantEl = bar.querySelector('[data-sticky-variant]');
    var imgEl = bar.querySelector('[data-sticky-img]');
    var priceWrap = bar.querySelector('[data-sticky-price]');

    /* Aparece só depois que o botão real sai da tela para cima — assim não
       cobre a página antes do usuário ter visto o produto. */
    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
        },
        { threshold: 0 }
      ).observe(realBtn);
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      realBtn.click();
    });

    document.addEventListener('variant:change', function (evt) {
      var v = evt.detail && evt.detail.variant;

      if (!v) {
        btn.disabled = true;
        if (window.theme && theme.strings) btn.textContent = theme.strings.unavailable;
        return;
      }

      btn.disabled = !v.available;
      if (window.theme && theme.strings) {
        btn.textContent = v.available
          ? realBtn.querySelector('[data-add-to-cart-text]').dataset.defaultText
          : theme.strings.soldOut;
      }

      if (priceEl) priceEl.innerHTML = money(v.price);

      if (priceWrap) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (onSale && !wasEl) {
          wasEl = document.createElement('s');
          wasEl.className = 'sticky-atc__was';
          priceWrap.insertBefore(wasEl, priceWrap.firstChild);
        }
        if (wasEl) {
          wasEl.innerHTML = onSale ? money(v.compare_at_price) : '';
          wasEl.style.display = onSale ? '' : 'none';
        }
      }

      if (variantEl) variantEl.textContent = v.name && v.title !== 'Default Title' ? v.title : '';

      if (imgEl && v.featured_image && v.featured_image.src) {
        imgEl.src = resize(v.featured_image.src, 120);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
